var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "236.71 157.276 202.063 184",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "html5a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E67DF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBAA",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 236.210052, 155.775848)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#html5a)",
    d: "M 176.5 1.5 C 176.833 1.5 186.445 7.386 186.5 10.5 C 186.5 57.833 186.5 105.167 186.5 152.5 C 135.167 152.5 83.833 152.5 32.5 152.5 C 32.5 102.167 32.5 51.833 32.5 1.5 C 80.5 1.5 128.5 1.5 176.5 1.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 236.210052, 155.775848)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "url(#html5a)",
    d: "M 0.5 20.5 C 1.167 20.167 32.167 1.5 32.5 1.5 C 32.5 51.833 32.5 102.167 32.5 152.5 C 27.291 155.598 22.291 158.932 17.5 162.5 C 17.167 162.5 0.833 172.5 0.5 172.5 C 0.5 121.833 0.5 71.167 0.5 20.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 236.210052, 155.775848)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "url(#html5a)",
    d: "M 186.5 152.5 C 186.5 105.167 186.214 34.603 186.486 34.602 C 191.58 34.582 197.934 34.536 202 35.5 C 202.5 85.499 202.667 135.499 202.5 185.5 C 142.833 185.5 83.167 185.5 23.5 185.5 C 22.127 184.988 17.883 180.102 17 177.5 C 16.501 172.511 16.334 167.511 16.5 162.5 C 21.291 158.932 32.167 152.5 32.5 152.5 C 83.833 152.5 135.167 152.5 186.5 152.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 236.210052, 155.775848)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(255, 255, 255)"
    },
    d: "M 100.5 49.5 C 117.836 46.879 124.002 53.879 119 70.5 C 118.167 71.333 117.333 72.167 116.5 73 C 111.264 74.339 105.93 74.839 100.5 74.5 C 100.5 66.167 100.5 57.833 100.5 49.5 Z M 128.5 84.5 C 134.677 81.158 138.843 76.158 141 69.5 C 144.73 51.092 137.563 39.925 119.5 36 C 106.171 35.5 92.837 35.333 79.5 35.5 C 79.5 63.167 79.5 90.833 79.5 118.5 C 86.5 118.5 93.5 118.5 100.5 118.5 C 100.5 108.5 100.5 98.5 100.5 88.5 C 103.777 88.216 106.943 88.55 110 89.5 C 113.394 97.288 117.061 104.955 121 112.5 C 127.412 120.614 135.245 122.614 144.5 118.5 C 144.5 114.5 144.5 110.5 144.5 106.5 C 143.209 106.737 142.209 106.404 141.5 105.5 C 136.04 99.336 131.706 92.336 128.5 84.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevit);
export default __webpack_public_path__ + "static/media/revit.93d8f3435dd616c9ee05046560493e4a.svg";
export { ForwardRef as ReactComponent };